import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      class: "fill",
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M20.0479 6.35134C20.2729 6.57638 20.3993 6.88155 20.3993 7.19974C20.3993 7.51794 20.2729 7.82311 20.0479 8.04814L10.4479 17.6481C10.2229 17.8731 9.91771 17.9995 9.59951 17.9995C9.28131 17.9995 8.97614 17.8731 8.75111 17.6481L3.95111 12.8481C3.73252 12.6218 3.61157 12.3187 3.6143 12.0041C3.61704 11.6894 3.74324 11.3885 3.96573 11.166C4.18822 10.9435 4.48919 10.8173 4.80383 10.8145C5.11847 10.8118 5.42159 10.9328 5.64791 11.1513L9.59951 15.1029L18.3511 6.35134C18.5761 6.12638 18.8813 6 19.1995 6C19.5177 6 19.8229 6.12638 20.0479 6.35134Z",
      fill: "#212225"
    }, null, -1)
  ])))
}
export default { render: render }